import { Dispatch } from "redux";
import { camelize } from "../../config/functions";
import { getStudentFeeReport } from "../../services/StudentFeesReport";



export interface StudentFeeReportParams {
    fromDate: string
    toDate: string
}

export interface StudentFeeReport {
    admissionNumber?: string
    name?: string
    billNo?: string
    title?:string
    billDate: string
    paidAmount: number
    paymentMode:string
}


export enum StudentFeeReportActionList {
    FETCH_STUDENT_FEE_REPORT = "FETCH_STUDENT_FEE_REPORT",
    CLEAR_STUDENT_FEE_REPORT = "CLEAR_STUDENT_FEE_REPORT"
}


export interface FetchStudentFeeReportAction {
    type: StudentFeeReportActionList.FETCH_STUDENT_FEE_REPORT
    data: StudentFeeReport[]
}

export interface ClearStudentFeeReportAction {
    type: StudentFeeReportActionList.CLEAR_STUDENT_FEE_REPORT
}

export type StudentFeeReportActions =
    | FetchStudentFeeReportAction
    | ClearStudentFeeReportAction;


export const fetchStudentFeeReportAction = (params: StudentFeeReportParams) => {
    return async (dispatch: Dispatch) => {
        return getStudentFeeReport(params).then(response =>{
            if (response.status === 200 && response.data.data) {
                const data = response.data.data.map((res: any) => {
                    let camelCase: any = {}
                    for (let i = 0; i < Object.keys(res).length; i++) {
                        const key = camelize(Object.keys(res)[i])
                        const value = Object.values(res)[i]
                        camelCase = { ...camelCase, [key]: value }
                    }
                    return camelCase
                });

                dispatch<FetchStudentFeeReportAction>({
                    type: StudentFeeReportActionList.FETCH_STUDENT_FEE_REPORT,
                    data
                });

                return Promise.resolve("Report fetched successfully");
            } else {
                throw response;
            }

        }).catch(error => {
            return Promise.reject(error.response ? error.response.data.message?error.response.data.message:'unable to get':'unable to get')
        })
    };
};

export const clearStudentFeeReportAction = () => {
    return (dispatch: Dispatch) => {
        dispatch<ClearStudentFeeReportAction>({
            type: StudentFeeReportActionList.CLEAR_STUDENT_FEE_REPORT
        });
    };
};
